export class BrowserUtil {
  static getCssVariableValue(variable: string): string {
    return getComputedStyle(document.documentElement).getPropertyValue(
      variable,
    );
  }
}
